/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorLogCompassCreate
 */
export interface ErrorLogCompassCreate {
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassCreate
     */
    firmware_version: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassCreate
     */
    compass_uuid: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassCreate
     */
    error_code: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassCreate
     */
    line_number: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassCreate
     */
    module: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassCreate
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassCreate
     */
    org_code: string;
}

/**
 * Check if a given object implements the ErrorLogCompassCreate interface.
 */
export function instanceOfErrorLogCompassCreate(value: object): value is ErrorLogCompassCreate {
    if (!('firmware_version' in value) || value['firmware_version'] === undefined) return false;
    if (!('compass_uuid' in value) || value['compass_uuid'] === undefined) return false;
    if (!('error_code' in value) || value['error_code'] === undefined) return false;
    if (!('line_number' in value) || value['line_number'] === undefined) return false;
    if (!('module' in value) || value['module'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    return true;
}

export function ErrorLogCompassCreateFromJSON(json: any): ErrorLogCompassCreate {
    return ErrorLogCompassCreateFromJSONTyped(json, false);
}

export function ErrorLogCompassCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorLogCompassCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'firmware_version': json['firmware_version'],
        'compass_uuid': json['compass_uuid'],
        'error_code': json['error_code'],
        'line_number': json['line_number'],
        'module': json['module'],
        'type': json['type'],
        'org_code': json['org_code'],
    };
}

export function ErrorLogCompassCreateToJSON(json: any): ErrorLogCompassCreate {
    return ErrorLogCompassCreateToJSONTyped(json, false);
}

export function ErrorLogCompassCreateToJSONTyped(value?: ErrorLogCompassCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firmware_version': value['firmware_version'],
        'compass_uuid': value['compass_uuid'],
        'error_code': value['error_code'],
        'line_number': value['line_number'],
        'module': value['module'],
        'type': value['type'],
        'org_code': value['org_code'],
    };
}

